/**
 * @generated SignedSource<<60f68d2ce3f8897e469d277828b4d83c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type ShoppingWithGrid_shoppingWith$data = {
  readonly items: ReadonlyArray<{
    readonly serviceId: string | null;
    readonly " $fragmentSpreads": FragmentRefs<"ShoppingWithTile_item">;
  } | null> | null;
  readonly quote: {
    readonly __typename: "ShoppingWithQuote";
  } | null;
  readonly title: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"ShoppingWithQuote_shoppingWith">;
  readonly " $fragmentType": "ShoppingWithGrid_shoppingWith";
};
export type ShoppingWithGrid_shoppingWith$key = {
  readonly " $data"?: ShoppingWithGrid_shoppingWith$data;
  readonly " $fragmentSpreads": FragmentRefs<"ShoppingWithGrid_shoppingWith">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ShoppingWithGrid_shoppingWith",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "title",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "ShoppingWithQuote",
      "kind": "LinkedField",
      "name": "quote",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "__typename",
          "storageKey": null
        }
      ],
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "concreteType": "Item",
      "kind": "LinkedField",
      "name": "items",
      "plural": true,
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "serviceId",
          "storageKey": null
        },
        {
          "args": null,
          "kind": "FragmentSpread",
          "name": "ShoppingWithTile_item"
        }
      ],
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ShoppingWithQuote_shoppingWith"
    }
  ],
  "type": "ShoppingWith",
  "abstractKey": null
};

(node as any).hash = "1d992e6c96ee09492009c59583327b34";

export default node;
